import api from '../../../utils/api';

export const checkScrapingStatus = async () => {
    try {
      const { data } = await api.get('/scrape/status');
      return data;
    } catch (error) {
      console.error('Error checking scrape status:', error);
      return { isScrapingInProgress: false };
    }
  };
  
  export const shouldStartAutoRefresh = (status, isCurrentlyRefreshing) => {
    return status.isScrapingInProgress && !isCurrentlyRefreshing;
  };
  
  export const shouldStopAutoRefresh = (status, isCurrentlyRefreshing) => {
    return !status.isScrapingInProgress && isCurrentlyRefreshing;
  };